// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__container-hjDQx1 {
  flex-direction: column;
  flex: 1;
  align-self: stretch;
  margin-left: 8px;
  display: flex;
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__container-hjDQx1 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-_THMV_ textarea {
  padding: 0 12px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__container-hjDQx1 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-with-value-uM9GUk textarea {
  -webkit-line-clamp: 1;
  padding: 0 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__container-hjDQx1`,
	"desc-not-focus": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-_THMV_`,
	"descNotFocus": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-_THMV_`,
	"desc-not-focus-with-value": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-with-value-uM9GUk`,
	"descNotFocusWithValue": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-description-index-module__desc-not-focus-with-value-uM9GUk`
};
export default ___CSS_LOADER_EXPORT___;
